<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">
    <div v-if="itemsGroup && itemsGroup.length > 0">
      <div v-for="item in itemsGroup" :key="item.rapp" class="mt-2 card">
         <Checkbox v-model="selectedQuietanze"  :value="item.rapp" />
         <label class="ml-2"> {{item.rapp}}</label>
         <hr>
         <div v-for="quietanza in item['quietanze']" :key="quietanza" class="formgrid grid mt-2">
            <div class="field col-12 md:col-3 flex align-items-center">
              {{quietanza.cliente}}
            </div>
            <div class="field col-12 md:col-3">
              <label>Data</label>
              <Calendar v-model="quietanza.date" dateFormat="dd/mm/yy" class="inputfield w-full" />
            </div>
            <div class="field col-12 md:col-3">
              <label>Mezzo Pagamento</label>
              <InputText v-model="quietanza.type_payment" class="inputfield w-full"  />
            </div>
            <div class="field col-12 md:col-3">
              <label>Importo</label>
              <InputText v-model="quietanza.amount" class="inputfield w-full"  />
            </div>
         </div>
      </div> 
    </div>
  </div>

  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import moment from 'moment'
import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";


export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'fatture-vendita-quietanza'}
    const loader = ref(false)
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const items = ref(props.data)
    const itemsGroup = ref()
    const selectedQuietanze = ref([]);
    const validationErrors = ref({})
    const submitted = ref(false)

    onMounted(() =>{
      groupForRappAndClient()
    })

    const groupForRappAndClient = async () => {
      itemsGroup.value = [];
      let arr = []
      items.value.forEach(el => {
        if (!arr[el.rappresentante]) {
            arr[el.rappresentante] = {
            rapp: el.rappresentante,
            invoices: [],
            quietanze: [],
          };
        }
        arr[el.rappresentante]['invoices'].push(el);
        if (!arr[el.rappresentante]['quietanze'][el.ragsoc]) {
          arr[el.rappresentante]['quietanze'][el.ragsoc] = {
            cliente: el.ragsoc,
            date: new Date(),
            type_payment: 'Contanti',
            amount: 0,
            n_invoices: []
          };
        }
        arr[el.rappresentante]['quietanze'][el.ragsoc]['amount'] += el.saldo ;
        arr[el.rappresentante]['quietanze'][el.ragsoc]['n_invoices'].push(el.numero) ;
      });

      for (const k in arr) {
        selectedQuietanze.value.push(k)
        itemsGroup.value.push(arr[k])
      }
      itemsGroup.value.forEach((el,i) => {
        for (const q in el.quietanze) {
          itemsGroup.value[i]['quietanze'].push(itemsGroup.value[i]['quietanze'][q])
          delete itemsGroup.value[i]['quietanze'][q]
        }
      });
      
    }

    const onOkButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);

      if (validateForm()) {
        loader.value = true

        let objs = itemsGroup.value.map(item => ({
          ...item,
          quietanze: item.quietanze.map(quietanza => ({
            ...quietanza,
            date: moment(quietanza.date).format('DD/MM/YYYY')
          }))
        }))
        .filter(el => selectedQuietanze.value.includes(el.rapp));

        service.downloadPdfFattureVenditaQuietanza(objs)
        .finally(()=>{
          loader.value = false
        })
      }
    }


    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const validateForm = () => {

      let temp = itemsGroup.value.filter(el => selectedQuietanze.value.includes(el.rapp))
      if (temp.length == 0) {
        toast.add({severity:'warn', summary: 'Attenzione', detail: 'Nessuna quietanza selezionata', group: page.name});
        return false
      }
      // let isValid = temp.every(el => el.amount != 0 && el.type_payment != '')
      let isValid = temp.every(item => {
        return item.quietanze.every(q => q.amount != 0 && q.type_payment != '');
      });
      
      if (!isValid) {
        toast.add({severity:'warn', summary: 'Attenzione', detail: 'Mezzo pagamento/importo non sono valorizzati o sono uguale a 0', group: page.name});
      }
      
      return isValid

    }


    return {
      page,
      items,
      itemsGroup,
      selectedQuietanze,
      loader,
      onCancelButton,
      onOkButton,
      submitted,
      validationErrors
    }
  }
}


</script>

<style scoped>
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  opacity: 0.4; /* Firefox */
}
</style>
